import BGCOverview from '@/apps/background_checks/overview/BGCOverview.vue';
import { requireSeeker } from '../guards/authGuards';

const backgroundCheckRoutes = [
  {
    path: '/background-checks/overview',
    name: 'bgc-overview',
    component: BGCOverview,
    beforeEnter: requireSeeker,
  },
];

export default backgroundCheckRoutes;
